import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const getMe = createWrappedAsyncThunk("user/getMe", async () => {
  return await httpClient.get(`get-me`);
});

export const getTenants = createWrappedAsyncThunk(
  "user/getTenants",
  async () => {
    return await httpClient.get("tenants");
  },
);

export const loginThunk = createWrappedAsyncThunk(
  "auth/login",
  async (credentials) => {
    const {
      data: { customer, token, refresh_token },
    } = await httpClient.publicPost(`verify-otp`, credentials);

    httpClient.setAccessToken(token);
    httpClient.setRefreshToken(refresh_token);

    return customer;
  },
);

export const magicSigninThunk = createWrappedAsyncThunk(
  "auth/magic-login",
  async (credentials) => {
    const {
      data: { customer, token, refresh_token },
    } = await httpClient.publicPost(`customer/magic-link`, credentials);

    httpClient.setAccessToken(token);
    httpClient.setRefreshToken(refresh_token);

    return customer;
  },
);
